import { type FC, useContext } from 'react';

import { BrowserRouter, Route } from 'react-router-dom';

import { CustomPropsContext } from './contexts';
import { DevPage, ExtrajudicialNotificationsPage } from './pages';

export const Routes: FC = () => {
  const { basePath } = useContext(CustomPropsContext);

  return (
    <BrowserRouter>
      <Route
        exact={true}
        path={`${basePath}/notificacoes-extrajudiciais`}
        component={ExtrajudicialNotificationsPage}
      />
      {process.env.APP_ENV === 'local' && (
        <Route exact={true} path={`${basePath}/`} component={DevPage} />
      )}
    </BrowserRouter>
  );
};
